import { useState } from "react";

import store from "../../store/store";
import Card from "../Card/Card";
import { gameActions } from "../Game/gameSlice";
import "./Hand.scss";

export default function HandSentence() {

  const gameState = store.getState().game;
  const player = gameState.player;

  function select(cardId: string) {
    if (player && !player.matchCardId) {
      setSentenceSelect(cardId);
    }
  }

  function confirm(cardId: string) {
    if (player) {
      store.dispatch(gameActions.selectSentenceCard(cardId));
    }
  }

  const [sentenceSelect, setSentenceSelect] = useState('');

  return (
    <>
      <div className="table-hand table-hand_sentence">
        {player?.hand.map((it) => {
          const isConfirmable = !player.matchCardId;
          return (
            <Card
              card={it}
              cards={player?.hand}
              key={it.cardId}
              isSelected={sentenceSelect === it.cardId}
              isSelectable={isConfirmable}
              onSelect={() => select(it.cardId)}
              onConfirm={() => confirm(it.cardId)}
              isConfirm={sentenceSelect === it.cardId && isConfirmable}
              isConfirmable={isConfirmable}
            />
          )}
        )}
      </div>
    </>
  )
}